import { useEffect, useState } from 'react';
import { useAppSelector } from 'redux/hooks';
import { BillingFormValues } from '../types';

export const formValues: BillingFormValues = {
  employerType: undefined,
  employerTypeValue: undefined,
  cardOwnerName: undefined,
  paymentType: undefined,
  pib: undefined,
  mbr: undefined,
  billingCompanyName: undefined,
  contactName: undefined,
  address: undefined,
  postalCode: undefined,
  contactPhone: undefined,
  countryId: undefined,
  cityId: undefined,
  city: undefined,
};

const transformBillingDataToFormValues = (billingData: any): BillingFormValues => {
  const result: any = { ...formValues };
  if (billingData) {
    if (!result.pib && billingData?.PIB) {
      result.pib = billingData.PIB;
    }

    if (!result.employerType && [0, 1, 2, 3, 4].indexOf(billingData.typeId) !== -1) {
      result.employerType = billingData.typeId;
    }

    if (!result.employerTypeValue && billingData.typeId === 1 && billingData.typeValue) {
      result.employerTypeValue = billingData.typeValue;
    }

    if (!result.billingCompanyName && billingData.websiteCompanyName) {
      result.billingCompanyName = billingData.websiteCompanyName;
    }

    if (!result.contactPhone && billingData.contactPhone) {
      result.contactPhone = billingData.contactPhone;
    }

    if (!result.contactName && (billingData.ime || billingData.prezime)) {
      result.contactName = [billingData.ime, billingData.prezime].join(' ');
    }

    if (!result.mbr && billingData.maticniBroj) {
      result.mbr = billingData.maticniBroj;
    }

    if (!result.cityId && billingData.cityId) {
      result.cityId = billingData.cityId;
    }

    if (!result.countryId && billingData.countryId) {
      result.countryId = billingData.countryId;
    }

    if (!result.city && billingData.cityName) {
      result.city = billingData.cityName;
    }

    if (!result.address && billingData.address) {
      result.address = billingData.address;
    }

    if (!result.postalCode && billingData.postalCode) {
      result.postalCode = billingData.postalCode;
    }
  }
  return result;
};

export const useInitialValues = () => {
  const billingData = useAppSelector((state) => state.User.get('loadedUser'));
  const [data, setData] = useState(transformBillingDataToFormValues(billingData));

  useEffect(() => {
    setData(transformBillingDataToFormValues(billingData));
  }, [billingData]);

  return data;
};
